/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { Line } from 'rc-progress';
import { get } from 'lodash';
import cx from 'classnames';
import {UploadPreviewProps} from "@broadleaf/admin-components/dist/common/components/UploadPreview";
import AssetPreview from '@broadleaf/admin-components/dist/common/components/AssetPreview';
import PDFAssetPreview from "./PDFAssetPreview";


/**
 * Component that applies styling for an upload around an AssetPreview,
 * and handles the translation of the returned preview to the expected
 * asset keys.
 */
export const PDFUploadPreview: React.FC<UploadPreviewProps> = ({
                                                                className,
                                                                isFailure,
                                                                isSuccess,
                                                                isUploading,
                                                                preview,
                                                                previewClassName,
                                                                previewStyle,
                                                                progress,
                                                                srcKey = 'src',
                                                                typeKey = 'type'
                                                            }) => (
                                                                <div
        className={cx(
        'UploadPreview',
        'tw-relative tw-rounded tw-border-2 tw-border-transparent tw-transition-border tw-duration-500 tw-ease-in-out',
{
    'tw-border-green-500': isSuccess,
    'tw-border-red-700': isFailure,
    'tw-border-blue-500': isUploading
},
className
)}
>
{preview && (
    <PDFAssetPreview
        className={cx(previewClassName, 'tw-h-full tw-w-full')}
    openInNewTab={false}
    src={get(preview, srcKey)}
    style={previewStyle}
    type={get(preview, typeKey)}
    />
)}
{isUploading && (
    <Line
        className="tw-absolute tw-bottom-4 tw-left-0 tw-right-0 tw-z-10 tw-mx-auto tw-w-4/5 tw-rounded-lg tw-border tw-border-secondary-900"
    strokeLinecap="square"
    prefixCls="UploadPreview"
    percent={progress}
    strokeWidth={6}
    trailWidth={6}
    />
)}
</div>
);

export default PDFUploadPreview;